export function disableBodyScroll(body: HTMLElement) {
    const scrollY = window.scrollY;
    body.classList.add("lock-scroll");
    body.style.top = `-${scrollY}px`;
  }
  
  export function enableBodyScroll(body: HTMLElement) {
    const scrollY = parseInt(body.style.top || '0') * -1;
    body.classList.remove("lock-scroll");
    body.style.top = '';
    window.scrollTo({top: scrollY });
  }